import { render, staticRenderFns } from "./SendingType.vue?vue&type=template&id=9a1d5ba4&"
import script from "./SendingType.vue?vue&type=script&lang=js&"
export * from "./SendingType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports